import { useEffect } from "react";
import type { SponsorPresenter } from "@/lib/sponsor/sponsorMoments";
import { recordWarRoomEvent } from "@/lib/warRoom/warRoomEngine";

export function SponsorMomentBadge({ sponsor }: { sponsor: SponsorPresenter }) {
  useEffect(() => {
    recordWarRoomEvent("sponsorImpressions");
  }, [sponsor.brand]);
  // Compact, single-line presenter chip. The verbose "Powered by VerseSport
  // Intelligence" tagline was wrapping into 3 lines next to the rest of the
  // card, breaking the layout. We render a short label only and rely on
  // hover/aria for the long-form attribution.
  const isAvailableSlot =
    sponsor.brand.toLowerCase().includes("disponible") ||
    sponsor.brand.toLowerCase().includes("available");
  const shortLabel = isAvailableSlot ? "Espacio patrocinable" : sponsor.brand;
  return (
    <div
      className="mt-1 inline-flex max-w-[180px] items-center gap-1.5 rounded-full border border-white/10 bg-black/60 px-2 py-[3px] text-[9px] font-semibold uppercase tracking-wider text-white/85 backdrop-blur-sm"
      style={{ boxShadow: `inset 0 0 0 1px ${sponsor.hex}66` }}
      title={sponsor.tagline ? `${sponsor.tagline} · ${sponsor.brand}` : sponsor.brand}
      aria-label={sponsor.tagline ? `${sponsor.tagline} ${sponsor.brand}` : sponsor.brand}
      onClick={() => recordWarRoomEvent("sponsorInteractions")}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: sponsor.hex }} aria-hidden />
      <span className="truncate">{shortLabel}</span>
    </div>
  );
}
